import { Popover } from '@superops/ui-design-system';
import { BackgroundIcon } from '@nile/components';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import InfoCard from './InfoCard';
import { isEmpty } from 'lodash';

let InfoPopupCardContainer = styled.div`
  padding: 16px;
  position: relative;
  .details {
    column-gap: 40px !important;
  }
`;

let InfoPopupCard = ({ activator, data, editMode, openRequesterModal }) => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const [popupActive, setPopupActive] = useState(false);
  let openPopupTimer;
  let closePopupTimer;

  useEffect(() => {
    if (mouseEnter) {
      openPopupTimer = setTimeout(() => {
        !popupActive && setPopupActive(true);
      }, 500);
      // return () => clearTimeout(timer);
    } else {
      closePopupTimer = setTimeout(() => {
        setPopupActive(false);
      }, 500);
    }
  }, [mouseEnter]);

  return (
    <Popover
      active={data && !isEmpty(data) && popupActive}
      activator={
        <div
          onMouseOver={() => {
            closePopupTimer && clearTimeout(closePopupTimer);
            !editMode && setMouseEnter(true);
          }}
          onMouseLeave={() => {
            openPopupTimer && clearTimeout(openPopupTimer);
            setMouseEnter(false);
          }}
          onClick={() => setPopupActive(false)}
        >
          {activator}
        </div>
      }
      onClose={setPopupActive}
      preferredPosition={'below'}
      preferredAlignment={'left'}
    >
      {data && !isEmpty(data) && (
        <InfoPopupCardContainer
          onMouseOver={() => closePopupTimer && clearTimeout(closePopupTimer)}
          onMouseLeave={() => {
            openPopupTimer && clearTimeout(openPopupTimer);
            closePopupTimer = setTimeout(() => {
              setPopupActive(false);
            }, 500);
          }}
        >
          {/* <BackgroundIcon
          className="close"
          url={`url(${envConfig.imageRoot}svg/close_black.svg)`}
          onClick={() => setPopupActive(false)}
        /> */}
          <InfoCard data={data} openRequesterModal={openRequesterModal} />
        </InfoPopupCardContainer>
      )}
    </Popover>
  );
};

export default InfoPopupCard;
